import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

type GetMaterialByIdResponse = { data: { items: Material[] } };

export const getMaterialById = (materialId: number): Promise<Material | undefined> =>
    (axios.get(`${API_URLS.MATERIAL}/${materialId}`) as unknown as Promise<GetMaterialByIdResponse>).then(
        (response) => response.data.items[0]
    );
